export const state = {
  drivers: [],
  systemDriver: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/drivers/state.js